import { SummaryRow } from '../../../Summary/SummaryRow';
import { IRisk } from 'types';
import { isFundingRisk } from '../../../../utilities/risks';

interface Props {
  id: string;
  showRisks: boolean;
  risk: IRisk['docsRisk']['birthCertificate'];
  isLegalDocument: boolean;
  inEnglish: boolean;
  hasTranslation: boolean;
  uploadedBy?: string;
}

export default function BirthCertificate({
  id,
  showRisks,
  risk,
  isLegalDocument,
  inEnglish,
  hasTranslation,
  uploadedBy,
}: Props) {
  if (isLegalDocument === undefined) {
    return <div>Uploaded by {uploadedBy ? uploadedBy : 'University'}</div>;
  }
  return (
    <>
      <SummaryRow
        key="isLegalDocument"
        label="Is Legal Document"
        fullLabel="Are you uploading a scan of the original legal document?"
        value={isLegalDocument ? 'Yes' : 'No'}
        isRisk={showRisks && isFundingRisk(risk, 'isLegalDocument', id)}
      />

      <SummaryRow
        key="inEnglish"
        label="English"
        fullLabel="Is the letter in English?"
        value={inEnglish ? 'Yes' : 'No'}
        isRisk={showRisks && isFundingRisk(risk, 'inEnglishOrHasTranslation', id)}
      />

      {!inEnglish && (
        <SummaryRow
          key="hasTranslation"
          label="Has Translation"
          fullLabel="Have you provided an English translation of the letter?"
          value={hasTranslation ? 'Yes' : 'No'}
          isRisk={showRisks && isFundingRisk(risk, 'inEnglishOrHasTranslation', id)}
        />
      )}
    </>
  );
}
